import { IMODALITIES } from '@ifit/gateway-challenge-store/models/modalitie-s';
import { DashboardEquipmentType } from './dashboard';
import { EquipmentType } from './models';

export function parseEqpTypeToModalityDash(equipmentType: DashboardEquipmentType | string): IMODALITIES {
  switch (equipmentType) {
    case 'cycle':
      return IMODALITIES.Bike;
    case 'run':
      return IMODALITIES.Treadmill;
    case 'rower':
      return IMODALITIES.Rower;
    case 'fusion':
    case 'strength':
      return IMODALITIES.Strength;
    default:
      return IMODALITIES.Any;
  }
}

export function parseEqpTypeToModality(equipmentType: EquipmentType): IMODALITIES {
  switch (equipmentType) {
    case EquipmentType.Bike:
      return IMODALITIES.Bike;
    case EquipmentType.Elliptical:
      return IMODALITIES.Elliptical;
    case EquipmentType.FreeStrider:
      return IMODALITIES.Elliptical;
    case EquipmentType.Fusion:
      return IMODALITIES.Strength;
    case EquipmentType.InclineTrainer:
      return IMODALITIES.Treadmill;
    case EquipmentType.Mirror:
      return IMODALITIES.Strength;
    case EquipmentType.Rower:
      return IMODALITIES.Rower;
    case EquipmentType.Shoes:
      return IMODALITIES.Strength;
    case EquipmentType.SpinBike:
      return IMODALITIES.Bike;
    case EquipmentType.StationaryBike:
      return IMODALITIES.Bike;
    case EquipmentType.Stepper:
      return IMODALITIES.Elliptical;
    case EquipmentType.Strider:
      return IMODALITIES.Elliptical;
    case EquipmentType.Strength:
      return IMODALITIES.Strength;
    case EquipmentType.StudioBike:
      return IMODALITIES.Bike;
    case EquipmentType.TDFBike:
      return IMODALITIES.Bike;
    case EquipmentType.Treadmill:
      return IMODALITIES.Treadmill;
    case EquipmentType.Vault:
      return IMODALITIES.Strength;
    case EquipmentType.VerticalElliptical:
      return IMODALITIES.Elliptical;
    default:
      return IMODALITIES.Any;
  }
}
